module.exports = __webpack_public_path__ + "img/LogoAlt.20e46ca7.svg";